import {
  AssignmentLate,
  AssignmentTurnedIn,
  People,
  Today,
  WarningAmber,
} from "@mui/icons-material";
import { Box, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import PieChartStyled from "../../component/PieChartStyled/PieChartStyled";
import { StatCard } from "../../component/StatCardStyled/StatCardStyled";
import DevisService from "../../services/devis.service";
import { useNavigate } from "react-router-dom";

function DashboardAdmin() {
  const navigate = useNavigate();

  const handleStatCardClick = () => {
    navigate("/users");
  };

  const handleclientsCardClick = () => {
    navigate("/clientsDevisList");
  };
  const [stats, setStats] = useState({
    nbClients: 0,
    nbDevis: {
      traites: 0,
      enCours: 0,
      nonTraites: 0,
      nonTraitesPlusDeuxJours: 0,
    },
    nbFactures: {
      payees: 0,
      livrees: 0,
      nonTraites: 0,
      nonTraitesPlusDeuxJours: 0,
      nonLivrees: 0,
      nonPayees: 0,

      payees: 2,
      livrees: 1,
      nonTraitesPlusDeuxJours: 0,
      nonLivrees: 1,
      nonPayees: 0,
    },
  });

  useEffect(() => {
    async function fetchStats() {
      const data = await DevisService.getStatistics();
      console.log("🚀 ~ fetchStats ~ data:", data);
      if (data) setStats(data?.data);
    }
    fetchStats();
  }, []);
  const hasNonZeroValue = (dataArray) =>
    dataArray.some((item) => item.value !== 0);

  const factureData = [
    {
      id: 0,
      value: stats?.nbFactures?.payees,
      label: "Payées",
      color: "#2e7d32",
    },
    {
      id: 1,

      value: stats?.nbFactures?.livrees,

      label: "livrées",
      color: "#ef6c00",
    },
    {
      id: 2,
      value: stats?.nbFactures?.nonTraitesPlusDeuxJours,
      label: "Non traités (>2j)",
      color: "#fff",
      background: "#d32f2f",
    },
    {
      id: 3,
      value: stats?.nbFactures?.nonLivrees,
      label: "Non Livrés (>2j)",
      color: "#d32f2f",
    },
    {
      id: 4,
      value: stats?.nbFactures.nonPayees,
      label: "Non payés",
      color: "#d32f2f",
    },
  ];
  const devisData = [
    {
      id: 0,
      value: stats?.nbDevis?.traites,
      label: "Traités",
      color: "#2e7d32",
    },
    {
      id: 1,

      value: stats?.nbDevis?.nonTraites,

      label: "Non traités (≤2j)",
      color: "#ef6c00",
    },
    {
      id: 2,
      value: stats?.nbDevis.nonTraitesPlusDeuxJours,
      label: "Non traités (>2j)",
      color: "#d32f2f",
    },
  ];

  const cleanedFactureData = factureData.filter(
    (item) => item.value !== undefined && item.value !== 0
  );
  return (
    <Box p={4}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Tableau de bord administrateur
      </Typography>

      <Grid container spacing={3} mb={4}>
        <Grid item xs={12} sm={6} md={4} onClick={handleStatCardClick}>
          <StatCard
            title="Nombre de clients"
            value={stats?.nbClients}
            Icon={People}
            color="#1976d2"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4} onClick={handleclientsCardClick}>
          <StatCard
            title="Devis traités"
            value={stats?.nbDevis?.traites}
            Icon={AssignmentTurnedIn}
            color="#2e7d32"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            title="Devis non traités"
            value={stats?.nbDevis?.nonTraites}
            Icon={AssignmentLate}
            color="#ef6c00"
          />
        </Grid>

        {stats?.nbDevis?.nonTraitesPlusDeuxJours !== 0 && (
          <Grid item xs={12} sm={6} md={4}>
            <StatCard
              title="Devis non traités > 2 jours"
              value={stats?.nbDevis?.nonTraitesPlusDeuxJours}
              Icon={Today}
              color="#fff"
              background="#d32f2f"
              textColor="#fff"
            />
          </Grid>
        )}
      </Grid>
      <Grid container spacing={3} mb={4}>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            title="Factures Payées"
            value={stats?.nbFactures?.payees}
            Icon={AssignmentTurnedIn}
            color="#2e7d32"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            title="Factures livrées"
            value={stats?.nbFactures?.livrees}
            Icon={AssignmentTurnedIn}
            color="#ef6c00"
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            title="Facture non Livrés"
            value={stats?.nbFactures?.nonLivrees}
            Icon={WarningAmber}
            color="#d32f2f"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <StatCard
            title="Factures non payés"
            value={stats?.nbFactures?.nonPayees}
            Icon={WarningAmber}
            color="#d32f2f"
          />
        </Grid>

        {stats?.nbFactures?.nonTraitesPlusDeuxJours !== 0 && (
          <Grid item xs={12} sm={6} md={4}>
            <StatCard
              title="Factures non traités (>2j)"
              value={stats?.nbFactures?.nonTraitesPlusDeuxJours}
              Icon={Today}
              color="#fff"
              background="#d32f2f"
              textColor="#fff"
            />
          </Grid>
        )}
      </Grid>

      {/* Graphiques circulaires */}
      <Grid container spacing={4}>
        {hasNonZeroValue(devisData) && (
          <PieChartStyled
            staticsData={devisData}
            title={"Devis"}
            key={"staticts-devis"}
          />
        )}
        {hasNonZeroValue(cleanedFactureData) && (
          <PieChartStyled
            staticsData={cleanedFactureData}
            title={"Factures"}
            key={"staticts-facture"}
          />
        )}
      </Grid>
    </Box>
  );
}

export default DashboardAdmin;
